function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M28.902 13.34h-2.223V6.67c0-1.842-1.493-3.335-3.335-3.335H6.67c-1.842 0-3.335 1.493-3.335 3.335v20.464l5.691-5.691c.213-.203.495-.318.79-.322h3.523v3.334c0 1.842 1.493 3.335 3.335 3.335h9.082c.294.004.576.12.79.323l5.69 5.691v-17.13c0-1.842-1.492-3.335-3.334-3.335zm-15.563 3.334v2.223H9.815c-.884.001-1.731.353-2.356.979l-1.901 1.9V6.67c0-.614.498-1.112 1.112-1.112h16.674c.614 0 1.111.498 1.111 1.112v6.67h-7.78c-1.843 0-3.336 1.492-3.336 3.334zm16.674 11.772l-1.9-1.9c-.625-.626-1.473-.978-2.357-.979h-9.082c-.614 0-1.111-.498-1.111-1.112v-7.78c0-.615.497-1.113 1.111-1.113h12.228c.614 0 1.111.498 1.111 1.112v11.772z",
  transform: "translate(-688 -2699) translate(688.571 2699.714)"
}))));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.822f34e5.svg";
export { ForwardRef as ReactComponent };